module.exports = __webpack_public_path__ + "media/images/icons/outlined/fullscreen-4e8446ecdd49f81a650be4536e752bb5.svg";